import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Lock, AlertCircle } from "lucide-react";
import { useAdminAuth } from "../../context/AdminAuthContext";

const AdminLogin = () => {
  const { admin, login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (admin) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      const redirect = location.state?.from || "/admin";
      navigate(redirect, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login mislukt.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-5 py-20"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <Lock size={16} className="text-[var(--tha-red)]" />
          <span className="text-xs font-mono-x tracking-[0.3em] text-[var(--tha-red)]">
            ADMIN — STAFF ONLY
          </span>
        </div>
        <h1 className="font-display text-5xl sm:text-6xl leading-none">
          BACK <span className="neon-red-text">OFFICE.</span>
        </h1>
        <p className="mt-4 text-sm text-[var(--tha-muted)]">
          Log in om bestellingen, nieuwsbrief en contactberichten te beheren.
        </p>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="mt-10 border border-[var(--tha-border)] bg-[#0a0a0a] p-6 sm:p-8 space-y-5"
        >
          <div>
            <label className="text-[10px] font-mono-x tracking-widest text-[var(--tha-muted)]">
              E-MAIL
            </label>
            <input
              data-testid="admin-email-input"
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-2 px-4 py-3 text-sm"
              placeholder="admin@..."
              autoComplete="username"
            />
          </div>
          <div>
            <label className="text-[10px] font-mono-x tracking-widest text-[var(--tha-muted)]">
              WACHTWOORD
            </label>
            <input
              data-testid="admin-password-input"
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-2 px-4 py-3 text-sm"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div
              data-testid="admin-login-error"
              className="flex items-start gap-2 border border-[var(--tha-red)] bg-[#1a0303] p-3 text-sm text-[var(--tha-red)]"
            >
              <AlertCircle size={14} className="mt-0.5 shrink-0" />
              {error}
            </div>
          )}

          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="btn-red w-full py-4 font-display tracking-wider disabled:opacity-60"
          >
            {loading ? "INLOGGEN..." : "INLOGGEN"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
